msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: cs\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-27 06:16\n"
"Last-Translator: \n"
"Language-Team: Czech\n"
"Plural-Forms: nplurals=4; plural=(n==1) ? 0 : (n>=2 && n<=4) ? 1 : 3;\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: cs\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "uzamčeno"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Příspěvky: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Poslední příspěvek: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automaticky"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "Skupina"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Vzájemné"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Vyžadováno"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Sleduji"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Sleduje vás"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# odpověď} few {# odpovědi} many {# odpovědi} other {# odpovědi}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Ověřeno"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "Připojeno <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Navždy"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Účet nelze načíst."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Přejít na stránku účtu"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Sledující"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Příspěvky"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Více"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> naznačil, že jejich nový účet je nyní:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Uživatelské jméno X zkopírováno"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "Nepodařilo se zkopírovat uživatelské jméno"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Zkopírovat uživatelské jméno"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Přejít na původní stránku profilu"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Zobrazit profilový obrázek"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Zobrazit hlavičku profilu"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Tento uživatel se rozhodl nezpřístupnit tyto informace."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} původní příspěvky, {1} odpovědi, {2} zvyšuje"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr ""

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr ""

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originál"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Odpovědi"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Boosty"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Statistiky příspěvku nejsou k dispozici."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Zobrazit statistiky příspěvku"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Poslední příspěvek: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Ztlumeno"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Blokováno"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Soukromá poznámka"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Zmínit <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Přeložit bio"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Upravit soukromou poznámku"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Přidat soukromou poznámku"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Upozornění povolena pro příspěvky @{username}."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Upozornění zakázána pro příspěvky @{username}."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Vypnout oznámení"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Povolit oznámení"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Boosty z @{username} povoleny."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Boosty z @{username} zakázány."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Zakázat boosty"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Povolit boosty"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Přidat/Odebrat ze seznamu"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Odkaz zkopírován"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "Nebylo možné zkopírovat soubor"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Kopírovat"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Sdílení zřejmě nefunguje."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Sdílet…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "Zrušeno ztišení @{username}"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Zrušit ztlumení <0>@{username}</0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Ztišit <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "Ztlumený @{username} pro {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "Nelze ztlumit @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Odstranit <0>@{username}</0> ze sledujících?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} odebrán ze sledujících"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Odstranit sledujícího…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "Blokovat <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "Odblokován @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "Uživatel @{username} zablokován"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "Nelze odblokovat uživatele @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "Nelze zablokovat uživatele @{username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Odblokovat <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Blok <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Nahlásit <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Upravit profil"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Zrušit žádost o sledování?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "Chcete přestat sledovat {0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Přestat sledovat…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Vybrat…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Sledovat"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Zavřít"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Přeložit bio"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "Nelze odstranit ze seznamu."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "Nelze přidat do seznamu."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Nelze načíst seznamy."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "Žádné seznamy."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nový seznam"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Soukromá poznámka o <0> @{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "Nelze aktualizovat soukromou poznámku."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Zrušit"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Uložit & zavřít"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "Nelze aktualizovat profil.."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "O mně"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Extra pole"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Štítek"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Obsah"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Uložit"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "uživatelské jméno"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "jméno domény serveru"

#: src/components/background-service.jsx:138
msgid "Cloak mode disabled"
msgstr "Režim zavření zakázán"

#: src/components/background-service.jsx:138
msgid "Cloak mode enabled"
msgstr "Režim skrytí aktivován"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Domovská stránka"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Vytvořit"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Máte neuložené změny. Zrušit tento příspěvek?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Můžete připojit pouze 1 soubor.} few {Můžete připojit pouze # souborů.} many {Můžete připojit pouze # souborů.} other {Můžete připojit pouze # souborů.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Vyskakovací okno"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Minimalizovat"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Zdá se, že jste zavřeli nadřazené okno."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Vypadá to, že již máte složené pole otevřené v nadřazeném okně a aktuálně publikované. Počkejte prosím, než se to udělá a zkuste to znovu později."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Vypadá to, že již máte v nadřazeném okně otevřené políčko. Vyskakování v tomto okně zruší změny, které jste provedli v nadřazeném okně. Pokračovat?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Ukázat v"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Odpověděd na @{0}’s příspěvek (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "Odpovídám na příspěvek uživatele @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Editace zdrojového příspěvku"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "Anketa musí mít alespoň dvě možnosti"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Některé volby anket jsou prázdné"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Některá média jsou bez popisu. Pokračovat?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "Příloha #{i} selhala"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "Varování o obsahu"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Upozornění na obsah nebo citlivá média"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Veřejný"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Neveřejný"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Pouze pro sledující"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Soukromá zmínka"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Poslat odpověď"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Upravit příspěvek"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "Co děláte??"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Označit média jako citlivá"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Přidat anketu"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Přidat vlastní emoji"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Odpovědět"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Aktualizovat"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr ""

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "Stahování GIFu…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Nepodařilo se stáhnout GIF"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Více…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Odesláno"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Popis obrázku"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Popis videa"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Popis audia"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Velikost souboru je příliš velká. Při nahrávání mohou vzniknout problémy. Zkuste zmenšit velikost souboru z {0} na {1} nebo nižší."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Rozměr je příliš velký. Při nahrávání mohou vzniknout problémy. Zkuste zmenšit rozměr z {0}×{1}px na {2}×{3}px."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Snímková frekvence je příliš vysoká. Při nahrávání mohou vzniknout problémy."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Odstranit"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Chyba"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Upravit popis obrázku"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Upravit popis videa"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Upravit popis audia"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Generování popisu. Počkejte prosím…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Nepodařilo se vytvořit popis{0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Nepodařilo se vytvořit popis"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Vytvořit popis…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Nepodařilo se vytvořit popis{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– experimentální</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Hotovo"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "Volba {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Více možností"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Trvání"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Odstranit anketu"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Vyhledat účty"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Přidat"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Chyba při načítání účtů"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Vlastní emoji"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Vyhledat emoji"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Chyba při načítání vlastních emoji"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Nedávno použité"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Ostatní"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} další…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Hledat GIFy"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Poháněno GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Zadejte pro vyhledávání GIFů"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "Zpět"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "Další"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Chyba při načítání GIFů"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Neodeslané koncepty"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Vypadá to, že máte neodeslané koncepty. Pojďme pokračovat tam, kde jste skončili."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Smazat koncept?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Chyba při mazání konceptu. Zkuste to prosím znovu."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Smazat…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Chyba při načítání stavu odpovědi!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Smazat všechny koncepty?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Chyba při mazání konceptů! Zkuste to prosím znovu."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Smazat vše…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Nebyly nalezeny žádné koncepty."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "Anketa"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Média"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Otevřít v novém okně"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Přijmout"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Odmítnout"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Přijato"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Odmítnuto"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nic k zobrazení"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Účty"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Zobrazit více…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Konec."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "Klávesové zkratky"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Nápověda pro klávesové zkratky"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "Následující příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "Předchozí příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Přeskočit carousel na další příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0>+ <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Přeskočit na předchozí příspěvek v karuselu"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0>+ <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Načíst nové příspěvky"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "Otevře detaily příspěvku"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> nebo <1>o </1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Rozbalit varování obsahu nebo<0/>přepínat rozšířené nebo sbalené vlákno"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Zavřít příspěvek nebo dialogové okno"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> nebo <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Zaměřit se na sloupec v režimu více sloupců"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> do <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Napsat nový příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Napsat nový příspěvek (nové okno)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Odeslat příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Hledat"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Odpovědět (nové okno)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Líbí se mi (oblíbené)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> nebo <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Boost"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Oblíbené položky"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Přepnout režim maskování"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Upravit seznam"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Seznam nelze upravit."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Seznam nelze vytvořit."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Název"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Zobrazit odpovědi členům seznamu"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Zobrazit odpovědi lidem, které sleduji"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Nezobrazovat odpovědi"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Skrýt příspěvky z tohoto seznamu na Domovské stránce/Sledované"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Vytvořit"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Smazat tento seznam?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Seznam nelze smazat."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Popis médií"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Přeložit"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Přečíst"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Otevřít originální média v novém okně"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Otevřít původní média"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Pokus o popis obrázku. Počkejte prosím,…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Nepodařilo se popsat obrázek"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Popište obrázek…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Zobrazit příspěvek"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Citlivá média"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrováno: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "Filtrovaný"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Příspěvek zveřejněn. Podívejte se na něj."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Odpověď odeslána. Podívejte se na ni."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Příspěvek aktualizován. Podívejte se na něj."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Znovu načíst stránku a aktualizovat?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nová aktualizace k dispozici…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr "Rekapitulace"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Zmínky"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Oznámení"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nový"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Seznam"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Všechny seznamy"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Záložky"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Líbí se mi"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Sledované hashtagy"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtry"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Ztlumení uživatelé"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Ztlumeni uživatelé…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Blokovaní uživatelé"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Blokovaní uživatelé…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Účty…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Přihlásit se"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Trendy"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Místní"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federovaná"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Zkratky / Sloupce…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Nastavení…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Oznámení"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Toto oznámení pochází z vašeho dalšího účtu."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Zobrazit všechna oznámení"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reagoval na váš příspěvek s {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} publikoval příspěvek."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} vás začal sledovat.} few {<0><1>{0}</1> lidé</0> vás začali sledovat.} other {<0><1>{0}</1> lidí</0> vás začalo sledovat.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} vás požádal o sledování."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Anketa, v níž jste hlasovali nebo byla vytvořena, skončila."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "Anketa, kterou jste vytvořili, skončila."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "Anketa, ve které jste hlasovali, skončila."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Příspěvek, na který jste reagovali, byl upraven."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} se zaregistroval/a."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} nahlásil {targetAccount}"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "Ztraceno spojení s <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Upozornění na moderování"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Admin z <0>{from}</0> pozastavil účet <1>{targetName}</1>, což znamená, že už nemůžete přijímat jejich aktualizace ani s nimi komunikovat."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Admin z <0>{from}</0> zablokoval <1>{targetName}</1>. Počet ovlivněných sledujících: {followersCount}, sledovaných: {followingCount}."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Zablokovali jste <0>{targetName}</0>. Odstranění sledujících: {followersCount}, následující: {followingCount}."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Váš účet obdržel upozornění na moderování."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Váš účet je zablokován."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Některé z vašich příspěvků byly označeny jako citlivé."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Některé z vašich příspěvků byly odstraněny."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "Vaše příspěvky budou od nynějška označeny jako citlivé."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Váš účet byl omezen."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Váš účet byl pozastaven."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Neznámý typ oznámení: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Boost/Líbilo se mi…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Líbí se…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Boostováno…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Sleduje…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Další informace <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Přečti si více →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Hlasoval/a"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Skrýt výsledky"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Hlasovat"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Obnovit"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Zobrazit výsledky"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> hlas} few {<1>{1}</1> hlasy} other {<1>{1}</1> hlasů}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> volič} few {<1>{1}</1> voliči} other {<1>{1}</1> voličů}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "Skončilo <0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Ukončeno"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "Konec <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Ukončení"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Nevyžádané"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Škodlivé odkazy, falešné interakce nebo opakované odpovědi"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Nelegální"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Porušuje zákon vaší nebo země serveru"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Porušení pravidla serveru"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Porušuje specifická pravidla serveru"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Porušení"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Ostatní"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Problém neodpovídá ostatním kategoriím"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Nahlásit příspěvek"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Nahlásit @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Čeká na posouzení"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Příspěvek nahlášen"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profil nahlášen"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Nelze nahlásit příspěvek"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Profil nelze nahlásit"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Jaký je s tímto příspěvkem problém?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Jaký je s tímto účtem problém?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Další informace"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Přeposlat na <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Odeslat hlášení"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Ztlumit {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Nebylo možné ztlumit {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Odeslat hlášení <0>+ ztlumit profil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Zablokován {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Nelze zablokovat {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Odeslat hlášení <0>+ Blokovat profil</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ účty, hashtagy & příspěvky</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Příspěvky obsahující <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Příspěvky označené <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Vyhledat <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Účty s <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Domů / Sledování"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Veřejná (Lokální/Federovaná)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Účet"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID seznamu"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Pouze místní"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instance"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Nepovinné, např. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Hledaný výraz"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Volitelné, pokud není pro více sloupců"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "např. PixelArt (Max 5, oddělený mezerami)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Pouze média"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Zkratky"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Zadejte seznam zkratek, které se zobrazí jako:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Plovoucí tlačítko"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Záložka/Panel nabídek"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Více sloupců"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "Není k dispozici v aktuálním režimu zobrazení"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Posunout nahoru"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Dolů"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Upravit"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Přidejte více než jednu zkratku/sloupec, aby to fungovalo."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "Zatím žádné sloupce. Klikněte na tlačítko Přidat sloupec."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Zatím žádné zkratky. Klepněte na tlačítko Přidat zkratku."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Nejste si jisti, co přidat?<0/>Zkuste nejdříve přidat <1>Domů / Sledování a oznámení</1>."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Max {SHORTCUTS_LIMIT} sloupců"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Maximálně {SHORTCUTS_LIMIT} zkratek"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Import/export"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Přidat sloupec…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Přidat zkratku…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Specifický seznam je volitelný. Pro režim více sloupců je seznam povinný, jinak se sloupec nezobrazí."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Pro režim více sloupců je vyžadován hledaný výraz, jinak nebude sloupec zobrazen."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Podporováno je více hashtagů. Oddělené mezerami."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Upravit zkratky"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Přidat zkratku"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Časová osa"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Seznam"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importovat/Exportovat <0>Zástupce</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Importovat"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Zde vložte zkratky"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "Stahuji uložené zkratky z instance serveru…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "Zkratky nelze stáhnout"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Stáhnout zkratky z instance serveru"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* Existuje v aktuálních zkratkách"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "Seznam nemusí fungovat, pokud je z jiného účtu."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Neplatný formát nastavení"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "Existuje v aktuálních zkratkách?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Budou připojeny pouze zkratky, které v současných zkratkách neexistují."

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "Žádné nové zkratky k importu"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Zkratky importovány. Překročeno max. {SHORTCUTS_LIMIT}, zbytek tedy není importován."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Zkratky importovány"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Importovat & připojit…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "Přepsat aktuální zkratky?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "Importovat zkratky?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "nebo přepsat…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Importovat…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Exportovat"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "Zkratky zkopírovány"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "Nelze kopírovat zkratky"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "Nastavení zkratky zkopírováno"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "Nelze kopírovat nastavení zástupce"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Sdílet"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "Ukládání zkratek na instanci serveru…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "Zkratky uloženy"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "Zkratky nelze uložit"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Synchronizujte se serverem instance"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0,plural, one{# znak} few {# znaky} many {# znaků} other{# znaků}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "Nezpracované zkratky JSON"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importovat/exportovat nastavení z/do instance serveru (experimentální)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boostnout</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Omlouváme se, vaše aktuální přihlášená instance nemůže komunikovat s tímto příspěvkem z jiné instance."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "Nelíbí se @{0}"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "Líbí se @{0}"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "Odebrali jste záložku z příspěvku od @{0}"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "Přidali jste příspěvek uživatele @{0} do záložek"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Zrušit boostnutí"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Citace"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "Některá média jsou bez popisu."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Starý příspěvek (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "Zrušili jste boostnutí příspěvku od @{0}"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "Boostnuli jste @{0}"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Boostnout…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "Nelíbí se mi"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "Líbí se mi"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Odebrat záložku"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Zobrazit příspěvek od <0>@{0}</0>"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Ukázat historii úprav"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Upraveno: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Vložit příspěvek"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "Ztlumení konverzace zrušeno"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Konverzace ztlumena"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "Nelze zrušit ztlumení konverzace"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "Nelze ztlumit konverzaci"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Zrušit ztlumení konverzace"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Ztlumit konverzaci"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "Příspěvek odepnut z profilu"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "Příspěvek připnut na profil"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "Nelze odepnout příspěvek"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "Příspěvek nelze připnout"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Odepnout z profilu"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Připnout na profil"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "Smazat tento příspěvek?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Příspěvek odstraněn"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "Příspěvek nelze odstranit"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Nahlásit příspěvek…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "Líbí se"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Boosty"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Záložky"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Připnuto"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Smazat"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# odpověď} few {# odpovědi} many {# odpovědi} other {# odpovědi}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Vlákna{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Zobrazit méně"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Zobrazit obsah"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Zobrazit média"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Upraveno"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Komentáře"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Historie úprav"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "Nepodařilo se načíst historii"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Načítání…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "HTML kód"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "HTML kód zkopírován"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "Nelze kopírovat HTML kód"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Přílohy médií:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Emoji účtu:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "statická URL"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Emoji:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Poznámky:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Toto je statické, nestylizované a bez skriptů. Možná budete muset použít vlastní styly a podle potřeby upravovat."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Hlasování v anketách není interaktivní, místo toho se zobrazí seznam s počty hlasů."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Mediální přílohy mohou být obrázky, videa, audio nebo jakékoli typy souborů."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "Příspěvek může být později upraven nebo odstraněn."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Náhled"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Poznámka: Tento náhled je lehce stylizovaný."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/><1/> boostnuto"

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Nové příspěvky"

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Zkuste to znovu"

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "Vlákno"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrované</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Automaticky přeloženo z {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Překlad…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Přeložit z {sourceLangText} (detekováno automaticky)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Přeložit z {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Překlad se nezdařil"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr ""

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Odpověď @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Nyní můžete tuto stránku zavřít."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Zavřít okno"

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr ""

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Příspěvky účtu"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Odpovědi)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Boosty)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Média)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Vymazat filtry"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Vyčistit"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Zobrazení příspěvku s odpovědmi"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Odpovědi"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Zobrazení příspěvků bez boostů"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Boosty"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Zobrazování příspěvků s médii"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Zobrazuji příspěvky označené štítkem #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Zobrazení příspěvků v {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Zatím zde není co vidět."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "Nelze načíst příspěvky"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Nelze získat informace o účtu"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Přepnout na instance účtu {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Přepněte na mou instanci (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Měsíc"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Současný"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Výchozí"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Přepněte na tento účet"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Zobrazit profil…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Nastavit jako výchozí"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Odhlásit se <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Odhlásit se…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Přidejte existující účet"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Poznámka: <0>Výchozí</0> účet bude vždy použit pro první načtení. Přepnuté účty budou přetrvávat i během relace."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Nelze načíst záložky."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "poslední hodina"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "poslední 2 hodiny"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "poslední 3 hodiny"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "poslední 4 hodiny"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "posledních 5 hodin"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "posledních 6 hodin"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "posledních 7 hodin"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "posledních 8 hodin"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "posledních 9 hodin"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "posledních 10 hodin"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "posledních 11 hodin"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "posledních 12 hodin"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "starší než 12 hodin"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Sledované štítky"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Skupiny"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Zobrazuji {selectedFilterCategory, select, all {všechny příspěvky} original {původní příspěvky} replies {odpovědi} boosts {bosty} followedTags {sledované štítky} groups {skupiny} filtered {filtrované příspěvky}}, {sortBy, select, createdAt {{sortOrder, select, asc {nejstarší} desc {nejnovější}}} reblogsCount {{sortOrder, select, asc {nejméně bostů} desc {nejvíce bostů}}} favouritesCount {{sortOrder, select, asc {nejméně lajků} desc {nejvíce lajků}}} repliesCount {{sortOrder, select, asc {nejméně odpovědí} desc {nejvíce odpovědí}}} density {{sortOrder, select, asc {nejméně husté} desc {nejhustší}}}} nejprve{groupBy, select, account {, seskupeno podle autorů} other {}}"

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr "Catch-up <0>beta</0>"

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr "Nápověda"

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "Co je tohle?"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Catch-up je samostatná časová osa pro sledované uživatele, která nabízí přehledný pohled na příspěvky s jednoduchým rozhraním inspirovaným e-mailem, což umožňuje snadné třídění a filtrování obsahu."

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr "Náhled rozhraní Catch-up"

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr "Rychlá rekapitulace"

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr "Rekapitulace příspěvků od těch, které sledujete."

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "Zobrazit všechny příspěvky od…"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr "až do maxima"

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr "Catch up"

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr "Překrývá se s vaší poslední rekapitulací"

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Poznámka: Vaše instance může zobrazit maximálně 800 příspěvků na domovské časové ose, bez ohledu na časové rozmezí. Může to být méně nebo více."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "Předchozí…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# příspěvek} few {# příspěvky} many {# příspěvků} other {# příspěvků}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr "Odstranit tuto rekapitulaci?"

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Poznámka: Budou uloženy pouze maximálně 3. Zbytek bude automaticky odstraněn."

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr "Načítání příspěvků…"

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr "To může chvíli trvat."

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr "Obnovit filtry"

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr "Nejlepší odkazy"

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr "Sdílel/a {0}"

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Vše"

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autor} few {# autoři} many {# autorů} other {# autorů}}"

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr "Seřadit"

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr "Datum"

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr "Hustota"

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr "Autoři"

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr "Žádný"

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr "Zobrazit všechny autory"

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr "Není třeba číst všechno."

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr "To je vše."

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr "Zpět na začátek"

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Odkazy sdílené lidmi, které sledujete, seřazené podle počtu sdílení, boostů a lajků."

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr "Třídit: Hustota"

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Příspěvky jsou tříděny podle informační hustoty nebo hloubky. kratší příspěvky jsou \"lehčí\" zatímco delší příspěvky jsou \"těžší\". Příspěvky s fotkami jsou \"těžší\" než příspěvky bez fotografií."

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr "Skupina: Autoři"

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Příspěvky jsou seskupeny podle autorů a seřazeny podle počtu příspěvků na autora."

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr "Další autor"

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr "Předchozí autor"

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr "Přejít na začátek"

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr "Filtrováno: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Nepodařilo se načíst lajky."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Domovská časová osa a seznamy"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Veřejná časová osa"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Konverzace"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profily"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nikdy"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nový filtr"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtr} few {# filtry} many {# filtrů} other {# filtrů}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Nepodařilo se načíst filtry."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Zatím žádné filtry."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Přidat filtr"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Upravit filtr"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Nepodařilo se upravit filtr"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Nelze vytvořit filtr"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Název"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Celé slovo"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Žádná klíčová slova. Přidejte jedno."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Přidat klíčové slovo"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# klíčové slovo} few {# klíčová slova} many {# klíčových slov} other {# klíčových slov}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtrovat od…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Zatím není implementováno"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Stav: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Změnit vypršení platnosti"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Vypršení platnosti"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimalizovat"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "skrytý"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Smazat tento filtr?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Nepodařilo se odstranit filtr."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Vypršelo"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr ""

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr ""

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Nepodařilo se načíst sledované hashtagy."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Zatím nesledujete žádné hashtagy."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "Není zde nic k zobrazení."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Nelze načíst příspěvky."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr ""

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr ""

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "S tímto štítkem zatím nikdo nic nepřidal."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Nepodařilo se načíst příspěvky s tímto štítkem"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} již není sledován"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr ""

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Přidat hashtag"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Odstranit hashtag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Přidat do zkratek"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr ""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr ""

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Přejít na jinou instanci…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr ""

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/home.jsx:234
msgid "See all"
msgstr ""

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr ""

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr ""

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr ""

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr ""

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr ""

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr ""

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:233
msgid "Continue"
msgstr ""

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "Nemáte účet? Vytvořte si účet!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Soukromé zmínky"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Soukromý"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Nikdo vás nezmínil :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Nepodařilo se načíst odpovědi."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "Nesledujete"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Kdo tě nesleduje"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "S novým účtem"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Nastavení oznámení"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Nová oznámení"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr ""

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr ""

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Pouze @zmínky"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Dnes"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Včera"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "Nelze načíst oznámení"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "Nastavení oznámení aktualizováno"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Filtrovat oznámení od lidí:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Filtr"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ignorovat"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "Aktualizováno <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Povolit"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Odmítnout"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Místní časová osa ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Federovaná časová osa ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Místní časová osa"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Federovaná časová osa"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr ""

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr ""

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Hashtagy"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr ""

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Zobrazit další účty"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr ""

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr ""

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr ""

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Zobrazit více příspěvků"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr ""

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Nastavení"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Vzhled"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr ""

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr ""

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr ""

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Velikost textu"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr ""

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr ""

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr ""

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr ""

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr ""

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr ""

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr ""

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr ""

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Přeložit do"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr ""

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr ""

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Generátor popisu obrázků"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr ""

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:692
msgid "About"
msgstr ""

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Přispět"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Ochrana osobních údajů"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr ""

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Verze:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Push notifikace (beta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:999
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Ankety"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Příspěvky"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Chyba: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "Nepodařilo se načíst odpovědi."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Zpět"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr ""

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr ""

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr ""

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr ""

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr ""

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr ""

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr ""

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr ""

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr ""

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

